// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"WhitelabelAncillaryBanner-module__ctaButton___gQGLt","modalContainer":"WhitelabelAncillaryBanner-module__modalContainer___9+tZ+"};